import { render, staticRenderFns } from "./AttachedWorkflowModal.vue?vue&type=template&id=48ab7776&scoped=true&"
import script from "./AttachedWorkflowModal.vue?vue&type=script&lang=ts&"
export * from "./AttachedWorkflowModal.vue?vue&type=script&lang=ts&"
import style0 from "./AttachedWorkflowModal.vue?vue&type=style&index=0&id=48ab7776&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ab7776",
  null
  
)

export default component.exports